import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import MainLayout from './components/layout/MainLayout';
import PrivateRoute from './components/auth/PrivateRoute';
import { ROUTES } from './constants/routes';
import './styles/global.scss';
import { getCurrentUser } from './services/auth';
import { useUserStore, useFilesStore } from './stores';
import { sourceTypeList } from './services/file';
// 动态引入页面组件
const Login = lazy(() => import('./pages/auth/Login'));
const Register = lazy(() => import('./pages/auth/Register'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));
const Profile = lazy(() => import('./pages/profile/Profile'));
const File = lazy(() => import('./pages/file/File'));
const Feedback = lazy(() => import('./pages/feedback/Feedback'));
// import ThemeTest from './pages/ThemeTest';
// import MessageTest from './pages/MessageTest';

function App() {
  const { setCurrentUser } = useUserStore.getState();
  const { setFileTypes } = useFilesStore.getState();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      handleInitBaseInfo()
    }
  }, [])

  const handleInitBaseInfo = async () => {
    if (localStorage.getItem('token')) {
      const response = await getCurrentUser();
      setCurrentUser(response)
      const res2 = await sourceTypeList()
      setFileTypes(res2)
    }
  }

  return (
    <ConfigProvider 
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#49AAA0',
          colorPrimaryHover: '#3d8f87',
          colorPrimaryActive: '#327a73',
          colorLink: '#49AAA0',
          colorLinkHover: '#3d8f87',
          colorLinkActive: '#327a73',
          colorInfo: '#49AAA0',
          colorInfoHover: '#3d8f87',
          colorInfoActive: '#327a73',
        },
        components: {
          Message: {
            colorBgElevated: '#000',
            colorText: '#fff',
            colorBorder: '#333',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          },
        },
      }}
    >
      <Router>
        <Suspense fallback={<div style={{textAlign: 'center', marginTop: 100}}>页面加载中...</div>}>
          <Routes>
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Register />} />
            <Route path={ROUTES.RESETPASSWORD} element={<ResetPassword />} />
            <Route
              path={ROUTES.PROFILE}
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Profile />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Feedback />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/file"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <File />
                  </MainLayout>
                </PrivateRoute>
              }
            />
            {/* <Route
            path="/theme-test"
            element={
              <PrivateRoute>
                <MainLayout>
                  <ThemeTest />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}
            {/* <Route
            path="/message-test"
            element={
              <PrivateRoute>
                <MainLayout>
                  <MessageTest />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout>
                    <Navigate to={ROUTES.FILE} replace />
                  </MainLayout>
                </PrivateRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </ConfigProvider>
  );
}

export default App;
